import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ToastService } from '../../../../services/toast.service';
import { Servico } from '../../../../types/Servico.type';
import { ServicosService } from './servicos.service';
import { IntegradorService } from '../../../../services/integrador.service';
import { ProcessoServico } from '../../../../types/ProcessoServico.type';

@Component({
  selector: 'app-servicos',
  templateUrl: './servicos.component.html',
  styleUrl: './servicos.component.css',
  providers: [DatePipe,ConfirmationService]
})
export class ServicosComponent {
  itensReversao: MenuItem[];

  servicos: Servico[] = [];
  servicosSelecionados: Servico[] = [];
  processando: boolean = false
  loadingSincronizar: boolean = false
  loadingIntegrar: boolean = false
  processo!: string;

  processos: ProcessoServico[] = []
  processosSelecionados: ProcessoServico[] = []

  constructor(private servicosService: ServicosService, private toastService: ToastService, private datePipe: DatePipe, private confirmationService: ConfirmationService) {
    this.itensReversao = [
      {
        label: 'Cancelar',
        icon: 'pi pi-times',
        command: () => {
          this.cancelar();
        },
      },
      {
        label: 'Estornar no PIMS',
        icon: 'pi pi-undo',
        command: () => {
          this.estornar();
        },
      },
      {
        label: 'Cancelar e Estornar no PIMS',
        icon: 'pi pi-times-circle',
        command: () => {
          this.estornar();
        },
      },
    ];
  }

  ngOnInit(): void {
    this.carregarProcessos();
    // this.getServicos();
  }

  carregarProcessos() {
    this.processando = true;

    this.servicosService.buscarProcessos().subscribe({
      next: (data) => {
        this.processos = data;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar os processos: " + error.error.message)
        this.processando = false;
      },
      complete: () => {
        this.processando = false
      }
    })
  }

  getServicos(){

    this.servicos = [];
    this.servicosSelecionados = [];

    if(this.processosSelecionados.length > 0){


       this.processando = true;

       this.servicosService.getServicos(this.processosSelecionados).subscribe({
         next: (data) => {
           this.servicos = data;
         },
         error: (error) => {
           this.processando = false
           this.toastService.erro("Erro", "Erro ao buscar as informações: " + error.error.message)
         },
         complete: () => {
           this.processando = false
         }
       })
     } else {
      this.toastService.alerta("Filtros", "Informe os filtros necessários");
    }
   }

   sincronizar(){
    this.servicosSelecionados = [];

    if(this.processosSelecionados.length > 0){
      this.loadingSincronizar = true

      this.processando = true

      this.servicosService.buscarPims(this.processosSelecionados).subscribe({
        next: (value) => {
          this.toastService.sucesso("Sucesso", "Busca realizada")
          this.servicos = [];
          this.processando = false
        },
        error: (err) => {
          this.loadingSincronizar = false
          this.processando = false
          this.toastService.erro("Erro", "Erro na solicitação: " + err.error.message)
        },
        complete: () => {
          this.loadingSincronizar = false
          this.processando = false
          this.getServicos();
        }
      })
    } else {
      this.toastService.alerta("Filtros", "Necessário selecionar 1 ou mais processos");
    }
   }

   integrar(){

    if(this.servicosSelecionados.length > 0){

      if (
      this.servicosSelecionados.filter(
        (nf) => nf.fgStatusInteg == 'IT' || nf.fgStatusInteg == 'ES'
      ).length > 0
    ) {
      this.toastService.alerta(
        'Integrada/Estornada',
        'Existem notas selecionadas que já foram integradas ou estornadas, favor verificar'
      );

      return;
    }

      this.loadingSincronizar = true
      this.processando = true

      console.log(this.servicosSelecionados)

      let ids = this.servicosSelecionados.map(m => m.idPagto)

      let corpo = {
        ids: ids,
        usuario: localStorage.getItem("cdUsuarioErp")
      }


      this.servicosService.enviarErp(ids).subscribe({
        next: (value) => {
          this.toastService.sucesso("Sucesso", "Integração realizada")


        },
        error: (err) => {
          this.loadingSincronizar = false
          this.processando = false
          this.toastService.erro("Erro", "Erro na solicitação: " + err.error.message)
          this.servicosSelecionados = []
        },
        complete: () => {
          this.loadingSincronizar = false
          this.processando = false
          this.getServicos();
          this.servicosSelecionados = []
        }
      })
    } else {
      this.toastService.alerta("Serviços", "Selecione registro para envio");
    }
  }

   getStatus(status: string): string{

     let stt = '';

     switch(status){
       case "IT":
         stt = "Integrado";
         break;
       case "IP":
         stt = "Enviando ao PIMS";
         break;
       case "AP":
         stt = "Aguardando Serviços";
         break;
       case "IE":
         stt = "Enviando ao ERP";
         break;
       case "ER":
         stt = "Erro";
         break;
     }

     return stt;
   }

   getSeverity(status: string): string {
     let stt = '';

     switch(status){
       case "IT":
         stt = "success";
         break;
       case "ER":
         stt = "danger";
         break;
       default:
         stt = "info";
         break;
     }

     return stt;
   }

  getDataPipeTransForm(data: string): string | null {
    return this.datePipe.transform( data,'yyyy-MM-dd');
  }

  exportar(){

    if(this.servicosSelecionados.length > 0){
      this.loadingSincronizar = true
      this.processando = true

      console.log(this.servicosSelecionados)

      let ids = this.servicosSelecionados.map(m => m.idPagto)

      let corpo = {
        ids: ids,
        usuario: localStorage.getItem("cdUsuarioErp")
      }

      this.servicosService
      .exportarServicos(
        ids
      )
      .subscribe({next: (value) => {
        const url = window.URL.createObjectURL(value);
        const a = document.createElement('a')
        a.href = url
        a.download = 'servicos.xlsx'
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      error: (error) => {
        this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error);
        this.loadingSincronizar = false;
        this.processando = false;
      },
      complete: () => {
        this.loadingSincronizar = false;
        this.processando = false;
      },

      });
    } else {
      this.toastService.alerta("Serviços", "Selecione registro para envio");
    }
  }

  cancelar() {
    if (
      this.servicosSelecionados.filter((ad) => ad.fgStatusInteg == 'ESTORNADO' || ad.fgStatusInteg == 'CANCELADO').length >
        0 ||
      this.servicosSelecionados.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros integrados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.servicosSelecionados.map((m) => m.idPagto);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    console.log(ids);

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.servicosService.cancelar(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Cancelamento realizado');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
          },
          complete: () => {
            this.loadingIntegrar = false;
            this.getServicos();
            this.servicosSelecionados = [];
          },
        });
      },
    });
  }

  estornar() {
    if (
      this.servicosSelecionados.filter((ad) => ad.fgStatusInteg != 'CANCELADO').length >
        0 ||
      this.servicosSelecionados.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros cancelados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.servicosSelecionados.map((ad) => ad.idPagto);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja estornar os itens selecionados no PIMS? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.servicosService.estornar(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Estorno realizada');
          },
          error: (err) => {
            console.error(err)
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error
            );
          },
          complete: () => {
            this.loadingIntegrar = false;
            this.getServicos();
            this.servicosSelecionados = [];
          },
        });
      },
    });
  }

  cancelarEstornar() {
    if (
      this.servicosSelecionados.filter((ad) => ad.fgStatusInteg != 'IT' && ad.fgStatusInteg != 'NI' && ad.fgStatusInteg != 'ER' && ad.fgStatusInteg != 'IE').length >
        0 ||
      this.servicosSelecionados.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros integrados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.servicosSelecionados.map((m) => m.idPagto);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    console.log(corpo);

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.servicosService.postCancelarEstornarServico(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Solicitação realizada');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
          },
          complete: () => {
            this.loadingIntegrar = false;
            this.getServicos();
            this.servicosSelecionados = [];
          },
        });
      },
    });
  }
}
